import React, { FunctionComponent } from 'react';
import { userSelectors } from '../../../../../../../../../app/resource/user/user.selectors';
import { useSelectWithParams } from '../../../../../../../../../utils/selector.utils';
import { Tooltip } from '../../../../../../../../common/Tooltip';
import { IKpiRowUserDetailsProps } from './types';
import { CircularAvatar } from '../../../../../../CustomAvatar';
import { isMemberPartOfMeeting, isMemberActiveInWorkspace } from '../../../../../../../../../utils/user.utils';
import { meetingSimpleSelectors } from '../../../../../../../../../app/resource/meeting-simple/meeting-simple.selectors';

export const KpiRowUserDetails: FunctionComponent<IKpiRowUserDetailsProps> = ({ userId, meetingId }) => {
  const user = useSelectWithParams(userSelectors.selectResourceById, userId);
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);

  return (
    user &&
    meeting && (
      <span className="kpi-header-user">
        <span className="small-avatar" style={{ width: '35px', height: '35px' }}>
          <Tooltip
            content={`${user.firstName} ${user.lastName}`}
            direction="top"
            bgColor="#13ac92"
            textColor="white"
            key={user.id}
          >
            <CircularAvatar
              src={user.image}
              title={`${user.firstName} ${user.lastName}`}
              classes={`img-fluid popup_button ${
                !isMemberPartOfMeeting(user, meeting) || !isMemberActiveInWorkspace(user) ? 'deleted-user' : ''
              }`}
            />
          </Tooltip>
        </span>
      </span>
    )
  );
};
